var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91675 10.2083C2.91675 8.59746 4.22258 7.29163 5.83342 7.29163H64.1668C65.7776 7.29163 67.0834 8.59746 67.0834 10.2083V26.25C67.0834 27.8608 65.7776 29.1666 64.1668 29.1666C62.5559 29.1666 61.2501 27.8608 61.2501 26.25V13.125H8.75008V51.0416H16.0417C17.6526 51.0416 18.9584 52.3475 18.9584 53.9583V56.5307L29.3207 51.3495C29.7257 51.147 30.1723 51.0416 30.6251 51.0416H37.1876C38.7984 51.0416 40.1043 52.3475 40.1043 53.9583C40.1043 55.5691 38.7984 56.875 37.1876 56.875H31.3136L17.3461 63.8587C16.442 64.3108 15.3682 64.2625 14.5084 63.731C13.6485 63.1996 13.1251 62.2608 13.1251 61.25V56.875H5.83342C4.22258 56.875 2.91675 55.5691 2.91675 53.9583V10.2083Z",
    fill: "#6BCF7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9168 40.8333C37.9168 34.39 43.1401 29.1666 49.5834 29.1666C56.0267 29.1666 61.2501 34.39 61.2501 40.8333C61.2501 42.5369 60.8849 44.1553 60.2286 45.6144L65.9888 50.2225C67.2466 51.2288 67.4506 53.0642 66.4443 54.3221C65.438 55.5799 63.6026 55.7839 62.3447 54.7776L56.5827 50.168C54.633 51.6323 52.2095 52.5 49.5834 52.5C43.1401 52.5 37.9168 47.2766 37.9168 40.8333ZM49.5834 35C46.3618 35 43.7501 37.6116 43.7501 40.8333C43.7501 44.055 46.3618 46.6666 49.5834 46.6666C52.8051 46.6666 55.4168 44.055 55.4168 40.8333C55.4168 37.6116 52.8051 35 49.5834 35Z",
    fill: "#6BCF7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5834 21.875C14.5834 20.2641 15.8893 18.9583 17.5001 18.9583H26.2501C27.8609 18.9583 29.1668 20.2641 29.1668 21.875C29.1668 23.4858 27.8609 24.7916 26.2501 24.7916H17.5001C15.8893 24.7916 14.5834 23.4858 14.5834 21.875Z",
    fill: "#6BCF7F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 27.7083C15.8893 27.7083 14.5834 29.0141 14.5834 30.625C14.5834 32.2358 15.8893 33.5416 17.5001 33.5416H35.0001C36.6109 33.5416 37.9168 32.2358 37.9168 30.625C37.9168 29.0141 36.6109 27.7083 35.0001 27.7083H17.5001Z",
    fill: "#6BCF7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSearch);
export default __webpack_public_path__ + "static/media/message-search.da197aa385fd8cf55e0dbec8469272ca.svg";
export { ForwardRef as ReactComponent };